var _ellipse, _ellipse2, _path, _ellipse3, _ellipse4, _path2, _ellipse5, _ellipse6, _path3, _ellipse7, _ellipse8, _path4, _ellipse9, _ellipse10, _path5, _ellipse11, _ellipse12, _path6, _ellipse13, _ellipse14, _path7, _ellipse15, _ellipse16, _path8, _ellipse17, _ellipse18, _path9, _ellipse19, _ellipse20, _path10, _ellipse21, _ellipse22, _path11;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIcOnlineScamServiceBody(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 238,
    height: 238,
    viewBox: "0 0 238 238",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 90.3089,
    cy: 109.714,
    rx: 35.5442,
    ry: 27.9276,
    fill: "#8D8D8D"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 90.3089,
    cy: 104.636,
    rx: 35.5442,
    ry: 27.9276,
    fill: "#C1C1C1"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M78.6253 115.319L70.9888 88.3934H77.4352L82.1956 107.336H82.4435L87.2535 88.3934H93.6502L98.5098 107.237H98.7577L103.469 88.3934H109.915L102.278 115.319H95.6833L90.6254 97.0712H90.2783L85.2204 115.319H78.6253Z",
    fill: "white"
  })), _ellipse3 || (_ellipse3 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 62.3313,
    cy: 158.754,
    rx: 35.5442,
    ry: 27.9276,
    fill: "#B2B2B2"
  })), _ellipse4 || (_ellipse4 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 62.3313,
    cy: 153.676,
    rx: 35.5442,
    ry: 27.9276,
    fill: "#D9D9D9"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M50.6477 164.36L43.0113 137.434H49.4576L54.218 156.377H54.466L59.2759 137.434H65.6727L70.5323 156.278H70.7802L75.491 137.434H81.9373L74.3009 164.36H67.7058L62.6479 146.112H62.3008L57.2428 164.36H50.6477Z",
    fill: "white"
  })), _ellipse5 || (_ellipse5 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 62.2395,
    cy: 143.851,
    rx: 35.5442,
    ry: 27.9276,
    fill: "#B2B2B2"
  })), _ellipse6 || (_ellipse6 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 62.2395,
    cy: 138.773,
    rx: 35.5442,
    ry: 27.9276,
    fill: "#D9D9D9"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M50.5559 149.457L42.9195 122.531H49.3658L54.1262 141.473H54.3742L59.1841 122.531H65.5809L70.4405 141.374H70.6884L75.3992 122.531H81.8455L74.2091 149.457H67.614L62.5561 131.209H62.209L57.151 149.457H50.5559Z",
    fill: "white"
  })), _ellipse7 || (_ellipse7 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 62.2395,
    cy: 128.528,
    rx: 35.5442,
    ry: 27.9276,
    fill: "#B2B2B2"
  })), _ellipse8 || (_ellipse8 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 62.2395,
    cy: 123.45,
    rx: 35.5442,
    ry: 27.9276,
    fill: "#D9D9D9"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M50.5559 134.134L42.9195 107.208H49.3658L54.1262 126.15H54.3742L59.1841 107.208H65.5809L70.4405 126.051H70.6884L75.3992 107.208H81.8455L74.2091 134.134H67.614L62.5561 115.886H62.209L57.151 134.134H50.5559Z",
    fill: "white"
  })), _ellipse9 || (_ellipse9 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 175.761,
    cy: 176.134,
    rx: 35.5442,
    ry: 27.9276,
    fill: "#B2B2B2"
  })), _ellipse10 || (_ellipse10 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 175.761,
    cy: 171.056,
    rx: 35.5442,
    ry: 27.9276,
    fill: "#D9D9D9"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M164.077 181.739L156.441 154.813H162.887L167.648 173.756H167.896L172.706 154.813H179.102L183.962 173.657H184.21L188.921 154.813H195.367L187.731 181.739H181.135L176.078 163.491H175.73L170.673 181.739H164.077Z",
    fill: "white"
  })), _ellipse11 || (_ellipse11 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 175.669,
    cy: 161.23,
    rx: 35.5442,
    ry: 27.9276,
    fill: "#B2B2B2"
  })), _ellipse12 || (_ellipse12 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 175.669,
    cy: 156.152,
    rx: 35.5442,
    ry: 27.9276,
    fill: "#D9D9D9"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M163.986 166.837L156.349 139.911H162.796L167.556 158.853H167.804L172.614 139.911H179.011L183.87 158.754H184.118L188.829 139.911H195.275L187.639 166.837H181.044L175.986 148.589H175.639L170.581 166.837H163.986Z",
    fill: "white"
  })), _ellipse13 || (_ellipse13 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 175.669,
    cy: 145.907,
    rx: 35.5442,
    ry: 27.9276,
    fill: "#B2B2B2"
  })), _ellipse14 || (_ellipse14 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 175.669,
    cy: 140.829,
    rx: 35.5442,
    ry: 27.9276,
    fill: "#D9D9D9"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M163.986 151.514L156.349 124.588H162.796L167.556 143.53H167.804L172.614 124.588H179.011L183.87 143.431H184.118L188.829 124.588H195.275L187.639 151.514H181.044L175.986 133.266H175.639L170.581 151.514H163.986Z",
    fill: "white"
  })), _ellipse15 || (_ellipse15 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 175.669,
    cy: 130.826,
    rx: 35.5442,
    ry: 27.9276,
    fill: "#B2B2B2"
  })), _ellipse16 || (_ellipse16 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 175.669,
    cy: 125.748,
    rx: 35.5442,
    ry: 27.9276,
    fill: "#D9D9D9"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M163.986 136.432L156.349 109.506H162.796L167.556 128.448H167.804L172.614 109.506H179.011L183.87 128.349H184.118L188.829 109.506H195.275L187.639 136.432H181.044L175.986 118.183H175.639L170.581 136.432H163.986Z",
    fill: "white"
  })), _ellipse17 || (_ellipse17 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 175.669,
    cy: 116.823,
    rx: 35.5442,
    ry: 27.9276,
    fill: "#B2B2B2"
  })), _ellipse18 || (_ellipse18 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 175.669,
    cy: 111.745,
    rx: 35.5442,
    ry: 27.9276,
    fill: "#D9D9D9"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M163.986 122.429L156.349 95.5028H162.796L167.556 114.445H167.804L172.614 95.5028H179.011L183.87 114.346H184.118L188.829 95.5028H195.275L187.639 122.429H181.044L175.986 104.181H175.639L170.581 122.429H163.986Z",
    fill: "white"
  })), _ellipse19 || (_ellipse19 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 175.669,
    cy: 103.542,
    rx: 35.5442,
    ry: 27.9276,
    fill: "#B2B2B2"
  })), _ellipse20 || (_ellipse20 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 175.669,
    cy: 98.4637,
    rx: 35.5442,
    ry: 27.9276,
    fill: "#D9D9D9"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M163.986 109.147L156.349 82.2215H162.796L167.556 101.164H167.804L172.614 82.2215H179.011L183.87 101.065H184.118L188.829 82.2215H195.275L187.639 109.147H181.044L175.986 90.8993H175.639L170.581 109.147H163.986Z",
    fill: "white"
  })), _ellipse21 || (_ellipse21 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 175.669,
    cy: 92.3338,
    rx: 35.5442,
    ry: 27.9276,
    fill: "#B2B2B2"
  })), _ellipse22 || (_ellipse22 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 175.669,
    cy: 87.2557,
    rx: 35.5442,
    ry: 27.9276,
    fill: "#D9D9D9"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M163.986 97.9395L156.349 71.0135H162.796L167.556 89.9559H167.804L172.614 71.0135H179.011L183.87 89.8567H184.118L188.829 71.0135H195.275L187.639 97.9395H181.044L175.986 79.6913H175.639L170.581 97.9395H163.986Z",
    fill: "white"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcOnlineScamServiceBody);
export default __webpack_public_path__ + "static/media/IcOnlineScamServiceBody.f94747a8501d5800aeb6c2252e3e9707.svg";
export { ForwardRef as ReactComponent };